/**
 * The tab strip's state (fix D / R3): the tabs this game has, and which one is
 * on. ONE `useShallow` selector over the store plus the ui store's `railTab`;
 * nothing here changes per move.
 */
import {useShallow} from 'zustand/react/shallow';

import {useLiveGame} from '@/Store/liveGameStore';

import {useV2Ui} from '../../../theme/useV2Ui';
import type {V2RailTab} from '../../../theme/useV2Ui';
import {RailTabSpec, activeTab, selectRailTabInput, tabsFor} from '../tabSpec';

export type RailTabsModel = {
  tabs: RailTabSpec[];
  active: V2RailTab;
  onPress: (tab: V2RailTab) => void;
};

export function useRailTabsModel(): RailTabsModel {
  const input = useLiveGame(useShallow(selectRailTabInput));
  const railTab = useV2Ui(s => s.railTab);
  const setRailTab = useV2Ui(s => s.setRailTab);
  const tabs = tabsFor(input);

  return {tabs, active: activeTab(tabs, railTab), onPress: setRailTab};
}

export default useRailTabsModel;
